import { render } from "./upload-with-preview.vue?vue&type=template&id=532bb57e"
import script from "./upload-with-preview.vue?vue&type=script&lang=js"
export * from "./upload-with-preview.vue?vue&type=script&lang=js"

import "./upload-with-preview.vue?vue&type=style&index=0&id=532bb57e&lang=css"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__